import React, { useEffect, useState } from "react";
import { Coordinates, defaultCoordinates } from "../../types/location";

export type LocationResult = {
  result?: Coordinates & {
    error?: string;
    errorMessage?: string;
  };
  isLoading: boolean;
};

type UseGPSProps = {};

export default function useGPS({}: UseGPSProps): [
  LocationResult,
  () => void,
  string
] {
  const [result, setResult] = React.useState<LocationResult>({
    isLoading: true,
    result: undefined,
  });
  const [log, setLog] = useState("");

  const GPSCall = function () {
    setResult((prev) => ({ isLoading: true }));
    var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기

    if (varUA.indexOf("android") > -1) {
      if (window.SANDI && window.SANDI.locationInstant) {
        setLog("android available");
        window.SANDI.locationInstant();
      } else if (window.SANDI && window.SANDI.location) {
        setLog("android available");
        window.SANDI.location();
      } else {
        if (process.env.NODE_ENV === "development") {
          handleLocation(
            defaultCoordinates.lat?.toString() ?? "",
            defaultCoordinates.lng?.toString() ?? ""
          );
        }
        setLog("android not available");
      }
    } else if (
      varUA.indexOf("iphone") > -1 ||
      varUA.indexOf("ipad") > -1 ||
      varUA.indexOf("ipod") > -1
    ) {
      //IOS
      setLog("ios called" + JSON.stringify(window.webkit));
      window.webkit?.messageHandlers.location.postMessage("location");
    } else {
      //아이폰, 안드로이드 외
      if (process.env.NODE_ENV === "development") {
        handleLocation(
          defaultCoordinates.lat?.toString() ?? "",
          defaultCoordinates.lng?.toString() ?? ""
        );
      }
      return "other";
    }
  };

  const handleLocation = function (lat: string, lng: string) {
    setLog(
      "====================handleLocation:::::::lat=" + lat + ",lng=" + lng
    );
    if (lat === "denied") {
      setResult({
        result: {
          error: "denied",
          errorMessage: "위치 정보를 허용해주세요.",
        },
        isLoading: false,
      });
    } else if (lat === "failed") {
      setResult({
        result: {
          error: "failed",
          errorMessage: "위치 정보를 가져오는데 실패하였습니다.",
        },
        isLoading: false,
      });
    } else {
      setResult({
        result: { lat: Number(lat), lng: Number(lng) },
        isLoading: false,
      });
      setLog("네이티브에서 전달받은 위치 lat=" + lat + ",lng=" + lng);
    }
  };


  const removeGPS = () => {
    try {
      setResult((prev) => ({ isLoading: false }));
      const varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기

      if (varUA.indexOf("android") > -1) {
        if (window.SANDI && window.SANDI.removeGPS) {
          window.SANDI.removeGPS();
        } 
      } else if (
        varUA.indexOf("iphone") > -1 ||
        varUA.indexOf("ipad") > -1 ||
        varUA.indexOf("ipod") > -1
      ) {
        window.webkit?.messageHandlers.location.postMessage("removeGPS");
      } else {
        return "other";
      }
    } catch {
      console.error("fail removeGPS")
    }
  }

  useEffect(() => {
    window.handleLocation = handleLocation;
    return () => {
      removeGPS();
    }
  }, []);

  return [result, GPSCall, log];
}
